import React from "react";
import classNames from "classnames";
import Icon from "../common/Icon";
import { toastSuccess } from "../../utils/toasts";
import { copyTextToClipboard } from "../../utils/actions/clipboard";
import { Button } from "../common";

type Props = {
  id: string;
  address: string;
  active: boolean;
  closeDropdown: () => any;
  popover?: boolean;
};

export const WalletsDropdown: React.FC<Props> = ({
  address,
  closeDropdown,
  popover = true,
}) => {
  const copyHandler = () => {
    copyTextToClipboard(address);
    toastSuccess("Wallet address copied!");
    closeDropdown();
  };

  return (
    <div
      className={classNames(
        popover ? "popover-dropdown-menu w-52" : "dropdown-menu"
      )}
    >
      <Button
        contentClassName="dropdown-menu-item flex flex-row justify-between"
        onClick={copyHandler}
        variant={Button.variant.TERTIARY}
      >
        Copy wallet
        <Icon icon="Copy" size={24} className="text-gray-500" disableFill />
      </Button>
    </div>
  );
};
